module.exports = __webpack_public_path__ + "media/images/partner/pic_3@2x-f7d9b51195d1e5e78da321f055f1069a.png";